module.exports = __webpack_public_path__ + "static/media/ehealth_50x_coins_banner_desktop.5d2530f9.jpg";